export const cityIdentityCookieDays = 365

export function setCookie(name, value, days = cityIdentityCookieDays) {
    let expires = "";
    if (days) {
        const date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        expires = "; expires=" + date.toUTCString();
    }
    
    // Получаем основной домен текущего сайта и добавляем перед ним точку
    const hostParts = window.location.hostname.split(".");
    const domain = hostParts.length > 1 
        ? "; domain=." + hostParts.slice(-2).join(".") 
        : "";

    document.cookie = `${name}=${value || ""}${expires}; path=/${domain}`;
}

export function eraseCookie(name) {
    const hostname = window.location.hostname;
    const domainParts = hostname.split('.');

    // Удаляем куку на текущем уровне домена
    document.cookie = `${name}=; Max-Age=-99999999; path=/;`;

    // Удаляем куку на всех уровнях домена (например, .site.ru и .localhost)
    if (domainParts.length > 1) {
        for (let i = 0; i < domainParts.length - 1; i++) {
            const domain = `; domain=.${domainParts.slice(i).join('.')}`;
            document.cookie = `${name}=; Max-Age=-99999999; path=/${domain}`;
        }
    }
}
export function getCookie(name) {
    var matches = document.cookie.match(new RegExp(
        "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
    ));
    return matches ? decodeURIComponent(matches[1]) : undefined;
}
